module.exports = __webpack_public_path__ + "static/22-56ed00b3e71e4cfcee769e289eabf331.jpg";